export default "__VITE_ASSET__$Pi3XVCGJe3hhcJFpC8Yrg__"